export const fluentExperiments = {
  fluentV9RibbonButtonIsEnabled: "SharedOnline.FluentV9RibbonButtonEnabled",
  fluentV9ButtonIsEnabled: "FluentV9ButtonBRSIsEnabled",
  fluentV9CompoundButtonIsEnabled: "SharedOnline.FluentV9CompoundButtonEnabled",
  fluentV9CheckboxIsEnabled: "SharedOnline.FluentV9CheckboxEnabled",
  // Flight to enable the Fluent V9 status bar in Excel
  fluentV9StatusBarButtonEnabled: "SharedOnline.FluentV9StatusBarButtonEnabled",
  fluentV9InputComboboxIsEnabled: "SharedOnline.FluentV9InputComboboxEnabled",
  fluentV9MessageBarIsEnabled: "SharedOnline.FluentV9MessageBarEnabled",
  fluentV9ToggleIconEnabled:
    "SharedOnline.ChangeGate.FluentV9ToggleIconEnabled",
  fluentV9RibbonIconPreviewGalleryIsEnabled:
    "SharedOnline.FluentV9RibbonIconPreviewGalleryEnabled",
  fluentV9RibbonFontStyleGalleryIsEnabled:
    "SharedOnline.FluentV9RibbonFontStyleGalleryEnabled",
  fluentV9TabListSpinButtonFocusIsEnabled:
    "SharedOnline.FluentV9TabSpinFocusIsEnabled",
  fluentV9TaskPaneIsEnabled: "SharedOnline.FluentV9TaskPaneIsEnabled",
  fluentV9TaskPaneResizeDisabled: "SharedOnline.fluentV9TaskPaneResizeDisabled",
  fluentV9DialogIsEnabled: "SharedOnline.FluentV9DialogEnabled",
  fluentV9RibbonControlsIsEnabled:
    "SharedOnline.FluentV9RibbonControlsIsEnabled",
  fluentV9ShortcutPillsIsEnabled: "SharedOnline.FluentV9ShortcutPillsIsEnabled",
  fluentV9HeaderButtonIsEnabled:
    "SharedOnline.ChangeGate.FluentV9HeaderButtonEnabled",
  newV9RibbonMenuEnabled: "SharedOnline.NewV9RibbonMenuEnabled",
  // Change gate to enable the fluent v9 status bar button in Word, PPT and Visio
  fluentV9StatusBarButtonInWordPPTVisioEnabled:
    "SharedOnline.ChangeGate.FluentV9StatusBarButtonInWordPPTVisioEnabled",
  fluentV9TabsterEnabled: "SharedOnline.fluentV9TabsterEnabled",
  disableFluentV9StatusBar: "DisableVNextStatusBar",
  fluentV9TooltipIsEnabled: "SharedOnline.fluentV9TooltipIsEnabled",
  fluentV9IconIsEnabled: "SharedOnline.FluentV9IconEnabled",
  fluentV9TableStylesPreviewGalleryIsEnabled:
    "SharedOnline.FluentV9TableStylesPreviewGalleryEnabled",
  fluentV9ToastNotificationIsEnabled:
    "Microsoft.Office.SharedOnline.FluentV9ToastNotificationEnabled",
  fluentV9ComponentLevelSwatchPickerIsEnabled:
    "SharedOnline.FluentV9ComponentLavelSwatchPickerEnabled",
  fluentV9LabelEnabled: "SharedOnline.fluentV9LabelEnabled",
  fluentV9KeytipEnabled: "SharedOnline.FluentV9KeytipEnabled",
  fluentV9MenuIsEnabled: "SharedOnline.fluentV9MenuEnabled",
  fluentV9ToggleIsEnabled: "SharedOnline.FluentV9ToggleEnabled",
  isSearchBoxKeyDownOnDismissEnabled:
    "SharedOnline.ChangeGate.OfficeVSO:10827025_SearchBoxKeyDownOnDismissEnabled",
  fluentV9DialogTouchEventEnabled:
    "SharedOnline.ChangeGate.OfficeVSO:10732497_fluentV9DialogTouchEventEnabled",
};
